// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zk3Ph","largestCol":"styles_largestCol__1ddQi","smallestCol":"styles_smallestCol__1u4e8"};